<template>
  <div class="section1 wow fadeInUp animated animated" style="visibility: visible;">
    <div class="s1-child px1280">
        <div class="s1-left">
            <h3>
                <router-link :to="`/news/views/${Groups[1].plateId}`" ><img
                        src="/static/img/lianjie.png"
                        alt=""><span>最新动态</span></router-link>
            </h3>
            <div class="s1-left-switch">
                <div class="owl-carousel" style="opacity: 1; display: block;"><router-link v-for="(article , index) in  Groups[0].articles" :key="index" :to="`/news/info/${article.plateid}/${article._id}`"
                                    class="item"
                                    target="_blank">
                                    <div><img
                                            :src="`${global.remoteIp}/uploads/${article.picsrc}`"
                                            alt=""></div>
                                    <p class="s1-left-tit">{{article.title.slice(0,18)}}{{article.title.length>18?'...':''}}</p>
                                    <p class="s1-left-cont">{{article.description?article.description.slice(0,213):''}}...
                                    </p>
                                </router-link></div>
                    <div class="owl-controls clickable">
                        <div class="owl-pagination">
                            <div  v-for="(article , index) in  Groups[0].articles" :key="index" :class="`owl-page ${index==0?'active':''}`"><span class=""></span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="s1-right" >
            <h2>协会动态</h2>
            <div  v-if="Groups[1].articles">
                <ul class="s4-rtext1">
                    <li v-for="(article , index) in  Groups[1].articles" :key="index">
                        <router-link :to="`/news/info/${article.plateid}/${article._id}`">
                            <i>【综合新闻】</i>{{article.title.slice(0,25)}}{{article.title.length>25?'...':''}}<span class="s4-r-date">{{article.addtime.slice(0,10)}}</span>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        </div>

        
        <div class="clear"></div>
    </div>
  
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    plates: Array,
    platename: String,
  },
  components: {},
  data() {
    return {
      articles: [],
      plate: {},
      Groups: [
        {
          name: "图片新闻", 
        },
        {
          name: "协会动态", 
        }
      ],
      global,
    };
  },
  mounted() {
    let watchflag = 0;
    for (let k = 0; k < this.Groups.length; k++) {
      if(this.Groups[k].name =='图片新闻')
      {
        this.$axios
        .get(
          `/api/articles?picnews=1&sort=-createdAt&limit=6`
        )
        .then((res) => {
          if (res.data) {
            this.Groups[k].articles = this.global
              .sortByTop(res.data.data);
              this.$forceUpdate();
              this.$nextTick(function() {
                $('.s1-left-switch .owl-carousel').owlCarousel({
                    items: 1,
                    autoPlay: true,
                    singleItem: true,
                    pagination: true,
                });
              });
          }
        });
      }
      for (let j = 0; j < this.plates.length; j++) {
        if (this.Groups[k].name == this.plates[j].name) {
          this.Groups[k].plateId = this.plates[j]._id;
          this.$axios
            .get(
              `/api/articles?plateid=${this.Groups[k].plateId}&sort=-createdAt&limit=7`
            )
            .then((res) => {
              if (res.data) {
                this.Groups[k].articles = this.global
                  .sortByTop(res.data.data);
                this.$forceUpdate();
              }
            });
          break;
        }
      }
    }
  },
  methods: {
    getDay(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return now.getDate();
    },
    getMonth(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getMonth() + 1}`;
    },
  },
};
</script>
<style scoped>
 .s1-right ul li {
            width: 100%;
            padding: 0;
            padding-left: 90px;
            margin-left: 0px;
            background: none;
            border: none;
            margin-top: 0px;
        }

        .s1-right ul li:hover {
            background: none;
            border: none;
            box-shadow: none;
        }
</style>
